import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 33333 33333"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#1c1b17}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <path
        d="M32857 16667c-15775 114-15822 218-4742 11448-11230-11080-11334-11034-11448 4742-115-15775-218-15822-11449-4742C16298 16885 16252 16781 476 16667c15775-115 15822-218 4742-11449C16449 16298 16552 16252 16667 476c114 15775 218 15822 11448 4742-11080 11231-11034 11334 4742 11449z"
        className="stroke1 fill"
        style={{
          stroke: "#1c1b17",
          strokeWidth: 952.382,
        }}

      />
      <path
        d="M32857 16667c-15775 114-15822 218-4742 11448-11230-11080-11334-11034-11448 4742-115-15775-218-15822-11449-4742C16298 16885 16252 16781 476 16667c15775-115 15822-218 4742-11449C16449 16298 16552 16252 16667 476c114 15775 218 15822 11448 4742-11080 11231-11034 11334 4742 11449z"
        className="fil0"
        style={{
          stroke: "#1c1b17",
          strokeWidth: 952.382,
          strokeLinecap: "round",
          strokeLinejoin: "round",
        }}
        className="stroke1 fill"

      />
    </g>
  </svg>
)
export default SvgComponent
